import styled from 'styled-components';
import {Status} from '../status/status-item';

const ServiceItem = ({service}) => {
    const StyledText = styled.div`
        color: ${service.status.code === 'READY' ? '#2c7800' : '#808080'};
    `;

    return (
        <tr>
            <td colSpan={2}>
                <StyledText>{service.name}</StyledText>
            </td>
            <td>
                <Status code={service.status.code} />
            </td>
        </tr>
    );
};

export {ServiceItem};
